<template>
  <div class="mx-auto sm:flex sm:flex-col">
      <!-- <header-component :title="$t('settings.update_your_plan')"></header-component> -->
      <p class="hidden mt-4 text-xl text-gray-500 sm:text-center"></p>
      <div class="relative mt-6 bg-gray-200 rounded-lg p-0.5 flex self-center sm:mt-2" role="group">
        <button v-on:click="changeInterval('month')" type="button" :aria-pressed="interval == 'month' ? 'true' : 'false'" :class="interval == 'month' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-700 hover:text-gray-900'" class="relative rounded-md py-2 w-1/2 text-sm font-medium whitespace-nowrap transition-colors duration-150 motion-reduce:transition-none focus:z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-bpblue sm:w-auto sm:px-8">{{$t('settings.monthly_billing')}}</button>
        <button v-on:click="changeInterval('year')" type="button" :aria-pressed="interval == 'year' ? 'true' : 'false'" :class="interval == 'year' ? 'bg-white shadow-sm text-gray-900' : 'text-gray-700 hover:text-gray-900'" class="ml-0.5 relative rounded-md py-2 w-1/2 text-sm font-medium whitespace-nowrap transition-colors duration-150 motion-reduce:transition-none focus:z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-bpblue sm:w-auto sm:px-8">{{$t('settings.yearly_billing')}}</button>
      </div>
  </div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="mt-10 space-y-4 sm:mt-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-3">
        <div v-for="plan in plans" :key="plan.uuid" class="relative rounded-lg divide-y divide-gray-200 bg-white shadow-lg border border-gray-200">
          <span v-if="isCurrentPlan(plan)" class="absolute -top-3 left-1/2 -translate-x-1/2 bg-gray-200 text-gray-700 text-xs font-semibold px-3 py-1 rounded-full">
            {{ $t('settings.current_plan_badge') }}
          </span>
          <div class="p-6">
            <h2 class="text-lg leading-6 font-medium text-gray-900">{{ plan.title }}</h2>
            <p class="hidden mt-4 text-sm text-gray-500">{{$t('settings.text_all_the_basics')}}</p>
            <p class="mt-8">
              <span class="text-2xl font-bold text-gray-900">{{ getPlanPrice(plan.prices).total }} €</span>
              <span v-if="interval=='month'" class="text-base font-medium text-gray-500"> / {{$t('settings.month')}}</span>
              <span v-if="interval=='year'" class="text-base font-medium text-gray-500"> / {{$t('settings.year')}}</span>
            </p>
            <button v-if="isCurrentPlan(plan)" type="button" disabled class="mt-8 block w-full bg-gray-300 border border-transparent rounded-md py-2 text-sm font-semibold text-gray-500 text-center">{{$t('settings.button_current_plan')}}</button>
            <button v-else-if="isPayingCustomer" type="button" v-on:click="requestPlanChange(plan)" class="mt-8 w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">{{$t('settings.button_change_plan')}}</button>
            <button v-else type="button" v-on:click="changeSubscription(getPlanPrice(plan.prices).uuid)" class="mt-8 w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">{{$t('settings.button_activate')}}</button>
          </div>
        </div>
      </div>

      <p class="mt-8 text-center text-sm text-gray-500">
        {{ interval === 'year' ? $t('settings.prices_no_vat_yearly') : $t('settings.prices_no_vat_monthly') }}
      </p>

      <p class="mt-8 text-center text-sm text-gray-500">
        {{ $t('settings.compare_features_text') }}
        <a href="https://brainspro.com/precios" target="_blank" class="text-bpblue hover:text-bpbluedeep underline">{{ $t('settings.compare_features_link') }}</a>
      </p>

      <p class="mt-8 text-center text-sm text-gray-500">
        {{ $t('settings.prefer_to_write_us') }}
        <a :href="planChangeMailto()" class="text-bpblue hover:text-bpbluedeep underline">soporte@brainspro.com</a>
      </p>

      <div class="mt-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-white border border-gray-200 rounded-md shadow p-6 flex flex-col sm:flex-row items-center justify-between gap-4 mb-10">
        <p class="text-gray-700 font-medium text-center sm:text-left">{{ $t('settings.talk_to_sales_title') }}</p>
        <a href="https://brainspro.com/contacto/" target="_blank" class="flex-shrink-0 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
          {{ $t('settings.talk_to_sales_button') }}
        </a>
      </div>

    </div>
</template>

<script>
import SaasPlanService from "../../../services/saas/SaasPlanService";
import saasSubscriptionService from "../../../services/saas/SaasSubscriptionService";
//import HeaderComponent from "../../common/HeaderComponent";
import {useAuthUserStore} from "../../../stores/auth";
import {useAcademiesStore} from "../../../stores/academies";

export default {
  name: "ChangeSubscriptionComponent",
  components: {
    //HeaderComponent,
  },
  data() {
    return {
      loading: false,
      interval: "month",
      plans: [],
      userSaasPlan: '',
      statusSaasPlan: '',
      userStateBlockButton: ''
    }
  },
  setup()
  {
    const authUserStore = useAuthUserStore()
    const academiesStore = useAcademiesStore()

    return {
      authUserStore,
      academiesStore
    }
  },
  mounted() {
    this.getSubscriptionsPlans()
  },
  methods: {
    getSubscriptionsPlans() {
      let academy_uuid = this.academiesStore.academy.uuid;
      this.loading = true;

      SaasPlanService.index(academy_uuid)
        .then((response) => {
          this.plans = response.data
        })
        .finally(() => {
          this.statusSaasPlan = this.authUserStore.user.academy.saas_subscriptions[0].status
          this.planKey = this.authUserStore.user.academy.saas_subscriptions[0].saas_plan.key
          //Si el estado del plan del usuario está en modo trialing, dejará que marque cualquier botón y no marcará ningún plan como activo.
          switch (this.statusSaasPlan)
          {
            case 'trialing':
              this.userSaasPlan = 'trialing'
              break
            case 'manual':
              this.userSaasPlan = 'manual'
              this.userStateBlockButton = this.planKey
              break
            case 'active':
              this.userStateBlockButton = this.planKey
              break
            case 'incomplete':
              this.userSaasPlan = 'incomplete'
              break
            case 'past_due':
              this.userSaasPlan = 'past_due'
              break
            case 'canceled':
              this.userSaasPlan = 'canceled'
              break
            case 'unpaid':
              this.userSaasPlan = 'unpaid'
              break
            case 'incomplete_expired':
              this.userSaasPlan = 'incomplete_expired'
              break
          }
        })
    },
    getPlanPrice(prices){
      let result = prices.find((price) => {
        return price.interval == this.interval
      })

      return result
    },
    changeInterval(interval) {
      this.interval = interval
    },
    changeSubscription(price_id) {
      console.log("I want to change my subscription with", price_id)
      let academy_uuid = this.academiesStore.academy.uuid;
      this.loading = true;

      saasSubscriptionService.post(academy_uuid, price_id)
      .then((response) => {
        console.log("Response from saas subscription service:", response)
        window.location = response.data.stripe.url
      })
      .catch((result) => {
        console.log("Error", result)
      })
      .finally(() => {
        this.loading = false;
      })
    },
    isCurrentPlan(plan) {
      return this.userStateBlockButton !== '' && plan.key === this.userStateBlockButton
    },
    requestPlanChange(plan) {
      window.location.href = this.planChangeMailto(plan)
    },
    planChangeMailto(plan = null) {
      let subject = encodeURIComponent(this.$t('settings.plan_change_email_subject'))
      let body = this.$t('settings.plan_change_email_body', {
        academy: this.authUserStore.user.academy.title,
        current: this.authUserStore.user.academy.saas_subscriptions[0].title
      })
      if (plan) {
        body += '\n' + this.$t('settings.plan_change_email_wanted', { wanted: plan.title })
      }

      return `mailto:soporte@brainspro.com?subject=${subject}&body=${encodeURIComponent(body)}`
    }
  },
  computed: {
    isPayingCustomer() {
      return ['active', 'manual'].includes(this.statusSaasPlan)
    }
  }
}
</script>

<style scoped>

</style>